import React, { Component } from 'react'
import ReactMarkdown from 'react-markdown'
import { StyledContent } from '../../styles/mixins'
import { StyledCard } from './style'
import apiService from '../../actions/apiService'
import { Row, Col, Spin } from 'antd';
class PostDetails extends Component {
  
  state = {
    isLoading: true,
    posts: [],
    postDetails: {},
  }
  
  async componentWillMount() {
    const id = this.props.match.params.id;
    const response = await apiService.getMethod('/OpenPosts/post?postid='+id);
    const stateUpdate = {isLoading: false};
    if (response) {
      stateUpdate.postDetails = response;
    }
    this.setState({
      ...stateUpdate,
    });
  }
  
  render() {
    const {isLoading, postDetails} = this.state;
    return (
      <StyledContent>
        <StyledCard title={postDetails.title || ''} bordered={false}>
          <Row gutter={16}>
            <Col sm={24} xs={24}>
              {
                isLoading && <Spin />
              }
              {
                !isLoading && <ReactMarkdown escapeHtml={false} source={postDetails.content || ''} />
              }
            </Col>
          </Row>
        </StyledCard>
      </StyledContent>
    )
  }
}

export default PostDetails



// WEBPACK FOOTER //
// ./src/components/open-posts/PostDetails.js